import { Location, NavigationGuard } from "vue-router";
import store from '../../store/index'
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";
import { getBackend } from "@service/router/getters";
import { ticketSystemIsEnabled } from '@common/serviceParamsHelper';
import { initSession } from "@service/router/helpers/initSession";
import { checkRestrictedPartner } from "@service/router/helpers/checkRestrictedPartner";
import { handleLiveStreams } from "@service/router/helpers/handleLiveStreams";
import { handleScrolls } from "@service/router/helpers/handleScrolls";
import { handleNextLocation } from "@service/router/helpers/handleNextLocation";

const guard: NavigationGuard = async (to, from, next) => {
    const backend = getBackend(to.params.backend);

    await initSession(backend, to);

    //ограничения для партнеров во время раннего доступа
    if (checkRestrictedPartner(to, next)) {return;}

    //@todo find a better way to resolve tickets routes
    if (ticketSystemIsEnabled() && to.name) {

        if (([
            RouteNamesEnum.ticketSystemIdeas,
            RouteNamesEnum.ticketSystemProblems,
            RouteNamesEnum.ticketSystemIdeaView,
            RouteNamesEnum.ticketSystemIdeaEdit,
            RouteNamesEnum.ticketSystemIdeaCreate,
            RouteNamesEnum.ticketSystemProblemView,
            RouteNamesEnum.ticketSystemProblemEdit,
            RouteNamesEnum.ticketSystemProblemCreate,
            RouteNamesEnum.ticketSystemDashboard,
            RouteNamesEnum.committeesList,
            RouteNamesEnum.committeesCreate,
            RouteNamesEnum.committeesEdit,
            RouteNamesEnum.committeesView
        ] as string[]).includes(to.name)) {
            next();
        } else {
            next({name: RouteNamesEnum.ticketSystemIdeas, params: {backend: to.params.backend}, hash: to.hash});
        }

        return;
    }

    to.meta['from'] = from;

    let location: Location | null = await handleNextLocation(to);

    if (location) {
        next(location);
        return;
    }

    next();

    handleLiveStreams(to, from);
    handleScrolls(to);
};

const adminGuard: NavigationGuard = async (to, _, next) => {
    if (store.getters['isAdmin']) {
        next();
    } else {
        next({name: "404", params: {backend: to.params.backend, eventId: to.params.eventId}})
    }
}

export { guard, adminGuard }
